import React, {
    useState,
    useEffect,
    useLayoutEffect,
    useCallback,
    useContext,
    useRef,
} from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ContextMenu } from "primereact/contextmenu";
import { InputNumber } from "primereact/inputnumber";
import { TabView, TabPanel } from "primereact/tabview";

import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Skeleton } from "primereact/skeleton";
import { InputTextarea } from "primereact/inputtextarea";

import { InputValorMonetario } from "../../../isp._comun/iu/componentes/widgets/InputValorMonetario";
import { InputNumerico } from "../../../isp._comun/iu/componentes/widgets/InputNumerico";
import GlobalContext     from "../../../isp._comun/iu/contexto/GlobalContext";

import Dialogo         from "../../../isp._comun/iu/_principal/componentes/layouts/Dialogo";
import EliminarVentana from "../../../isp._iu.start.principal/reductores/acciones/widgets/EliminarVentana";
import { ModosOp }     from "../../../isp._comun/iu/_principal/constantesIuPrin";

import * as Action   from "../../reductores/acciones/dispatch/_ActionsDispatch";
import ActionPlanSet from "../../reductores/acciones/ActionPlanSet";
import SetTipoPlan   from "../../reductores/acciones/dispatch/SetTipoPlan";

import ComandoAPI  from "../ComandoAPI";
// import { TiposDePlan, Moneda, Udm } from "../../../isp.žapi.planes/constantesApiPlanes";
import { EstadosPlanLabel }   from "./žconstantesIuLayoutPlanes";
import * as ModelosDeCombos from "./ModeloDeCombos_Planes";


const DialogoPlanLayout = ({
    ventana,
    estadoDCF,
    dispatchDCF,
    registrarPlanCommand,
    actualizarPlanCommand,
    buscarUnSoloPlanCommand,
}) => {
    const { dispatchPrincipal } = useContext(GlobalContext);

    // const isMounted = useRef(false);
    // const inputnumeral = useRef(null);

    /* useEffect(() => {
        console.log("use effect se monto el componente padre ----");
        console.log(inputnumeral);
        // inputnumeral.current.maxLength=6;
    }, []); */

    useEffect(() => {
        if (estadoDCF.flag.cargandoEntidad) {
            buscarUnSoloPlanCommand.ejecutar(estadoDCF.domain.screen.idPlan);
        }
        return () => {};
    }, [estadoDCF.flag.cargandoEntidad]);

    useEffect(() => {
        if (!estadoDCF.flag.procesandoComando) {
            return;
        }

        let comando = new ComandoAPI();
        if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) {
            comando = registrarPlanCommand;
            registrarPlanCommand.ejecutar();
        }
        if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) {
            comando = actualizarPlanCommand;
            actualizarPlanCommand.ejecutar();
        }
        return () => {
            comando.cancelar();
        };
    }, [estadoDCF.flag.procesandoComando]);

    const cancelarClick = (eventoSynDom) => {
        dispatchPrincipal(new EliminarVentana(ventana));
        eventoSynDom.stopPropagation();
    };

    const header = {
        elementoReact: <p className="p-2 bg-gradient-to-r from-purple-100">Plan</p>,
        enProgreso: estadoDCF.flag.procesandoComando,
    };

    const labelBotonAccion = (() => {
        if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) return "Guardar";
        if (estadoDCF.flag.modoOperacion === ModosOp.OK) return "   OK    ";
        if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) return "Modificar";
    })();

    const footer = (
        <div>
            <Button
                label={labelBotonAccion}
                icon="pi pi-check"
                onClick={(eventoSynDom) => {
                    if (estadoDCF.flag.modoOperacion === ModosOp.CREAR) {
                        dispatchDCF(new Action.GuardarPlan());
                        // registrarClienteAFacturar();
                        return;
                    }
                    if (estadoDCF.flag.modoOperacion === ModosOp.MODIFICAR) {
                        dispatchDCF(new Action.ActualizarPlan());
                        // actualizarClienteAFacturar();
                        return;
                    }
                    if (estadoDCF.flag.modoOperacion === ModosOp.OK) {
                        cancelarClick(eventoSynDom);
                        return;
                    }
                }}
                loading={estadoDCF.flag.procesandoComando}
                iconPos="left"
                className="whitespace-pre"
            />
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={(eventoDom) => cancelarClick(eventoDom)}
                disabled={estadoDCF.flag.procesandoComando}
                // className="w-32"
            />
        </div>
    );

    /* let bloqueTipoDePlan = null;

    if(estadoDCF.flag.modoOperacion === ModosOp.CREAR){
        bloqueTipoDePlan = 
            <Dropdown
                value={estadoDCF.domain.screen.tipoPlan}
                options={ModelosDeCombos.tiposPlan}                          
                onChange={(e) => {
                    dispatchDCF(new SetTipoPlan("tipoPlan", e.value));
                }}
                className="p-0 w-full rounded-none"
                // panelClassName="p-0"
                // panelStyle={{ padding: 0 }}
                disabled={estadoDCF.flag.procesandoComando}
            />
    }else{
        const labelTipoPlan = ModelosDeCombos.tiposPlan.find((tipoPlan)=>{
            if(tipoPlan.value === estadoDCF.domain.screen.tipoPlan)return true;
        });
        bloqueTipoDePlan = labelTipoPlan.label;
    } */

    let bloqueCampos = (
        <>
            <div className="mr-10">
                <div className="flex mb-2">
                    <div className="w-24 shrink-0">Nombre : </div>
                    <div className="pl-0">
                        <InputText
                            id="in"
                            value={estadoDCF.domain.screen.nombre}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionPlanSet("nombre", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            maxLength={40}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={estadoDCF.error.nomBlanc ? "mb-1.5 block p-error" : "hidden"}
                        >
                            Se requiere Nombre del Plan.
                        </small>
                        <small
                            id=""
                            className={estadoDCF.error.nomMF ? "mb-1.5 block p-error" : "hidden"}
                        >
                            El formato del Nombre es incorrecto.
                        </small>
                    </div>
                </div>
                <div className="flex mb-0.5">
                    <div className="w-24 shrink-0">Descripcion : </div>
                    <div className="pl-0">
                        <InputTextarea
                            id="in"
                            value={estadoDCF.domain.screen.descripcion}
                            className="p-0 w-full rounded-none"
                            onChange={(e) =>
                                dispatchDCF(
                                    new ActionPlanSet("descripcion", e.target.value)
                                    // new Action.SetNombres(e.target.value)
                                )
                            }
                            rows={4}
                            cols={31}
                            maxLength={200}
                            autoResize={false}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                    </div>
                </div>
            </div>
            <div>
                <div className="flex mb-2">
                    <div className="w-28">Precio : </div>
                    <div>
                        <InputValorMonetario
                            onChange={(e) => {
                                const decimalEntrante=e.valor;
                                if (decimalEntrante === null) {
                                    // if(inputEntrante===""){
                                    dispatchDCF(new ActionPlanSet("precio", ""));
                                    return;
                                }
                                dispatchDCF(new ActionPlanSet("precio", decimalEntrante));
                            }}
                            /* onCambio={(e) => {
                                // console.log("---onChange--- InputNumerico en Dialog");
                                const inputEntrante = e.value;

                                if (inputEntrante === null) {
                                    // if(inputEntrante===""){
                                    dispatchDCF(new ActionPlanSet("precio", ""));
                                    return;
                                }

                                const stringNumberEntrante = inputEntrante.toFixed(2);
                                dispatchDCF(new ActionPlanSet("precio", stringNumberEntrante));
                            }} */
                            valor={
                                estadoDCF.domain.screen.precio === ""
                                    ? null
                                    : estadoDCF.domain.screen.precio
                            }
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.precioBlanc ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            Se requiere Precio del Plan.
                        </small>
                    </div>
                </div>
                <div className="flex mb-2">
                    <div className="w-28">Moneda : </div>
                    <div>
                        <Dropdown
                            value={estadoDCF.domain.screen.moneda}
                            options={ModelosDeCombos.monedas}
                            onChange={(e) => {
                                dispatchDCF(new ActionPlanSet("moneda", e.target.value));
                                // dispatchDCF(new Action.SetTipoDoc(e.value));
                            }}
                            // placeholder="Selecciona un Tipo"
                            className="p-0 w-full rounded-none"
                            // panelClassName="p-0"
                            // panelStyle={{ padding: 0 }}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                    </div>
                </div>

                <div className="flex  mb-2">
                    <div className="w-28 shrink-0">Unidad : </div>
                    <div className="pl-0">
                        <Dropdown
                            value={estadoDCF.domain.screen.udm}
                            options={ModelosDeCombos.udms}
                            /* options={ModelosDeCombos.udms.filter((planCombo) => {
                                return estadoDCF.domain.screen.combos.udms.includes(
                                    planCombo.value
                                );
                            })} */
                            onChange={
                                (e) => dispatchDCF(new ActionPlanSet("udm", e.target.value))
                                // dispatchDCF(new Action.SetSexo(e.value))
                            }
                            placeholder="Seleccionar..."
                            className="p-0 w-full rounded-none"
                            // panelClassName="p-0"
                            // panelStyle={{ padding: 0 }}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.sexoBlanc ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            Se requiere elegir un Género.
                        </small>
                    </div>
                </div>
                <div className="flex mb-2">
                    <div className="w-28">Ancho/Banda : </div>
                    <div>
                        <InputNumerico
                            onChange={(e) => {

                                const decimalEntrante = e.valor;

                                if (decimalEntrante === null) {
                                    // if(inputEntrante===""){
                                    dispatchDCF(new ActionPlanSet("anchoBanda", ""));
                                    return;
                                }

                                // const stringNumberEntrante = inputEntrante.toFixed(2);
                                dispatchDCF(new ActionPlanSet("anchoBanda", decimalEntrante));
                            }}
                            valor={
                                estadoDCF.domain.screen.anchoBanda === ""
                                    ? null
                                    : estadoDCF.domain.screen.anchoBanda
                            }
                        />
                        <small
                            id=""
                            className={
                                estadoDCF.error.anchoBandBlanc ? "mb-1.5 block p-error" : "hidden"
                            }
                        >
                            Se requiere Ancho de Banda <br/> para el Plan.
                        </small>
                    </div>
                </div>
                <div className="flex mb-2">
                    <div className="w-28 shrink-0">Unid. A/B : </div>
                    <div>    
                        <Dropdown
                            value={estadoDCF.domain.screen.unidAnchoBanda}
                            // options={ModelosDeCombos.tiposPlan}
                            options={ModelosDeCombos.udsAnchoBanda}                          
                            onChange={(e) => {
                                dispatchDCF(new ActionPlanSet("unidAnchoBanda", e.value));
                                // dispatchDCF(new SetTipoPlan("tipoPlan", e.value));
                            }}
                            className="p-0 w-full rounded-none"
                            // panelClassName="p-0"
                            // panelStyle={{ padding: 0 }}
                            disabled={estadoDCF.flag.procesandoComando}
                        />
                    </div>
                </div>
            </div>
        </>
    );

    let bloqueAtributos = null;

    if (estadoDCF.flag.cargandoEntidad) {
        bloqueAtributos = (
            <>
                <div className="flex flex-row justify-between">
                    <Skeleton width="45%" height="6rem"></Skeleton>
                    <Skeleton width="40%" height="6rem"></Skeleton>
                </div>
                <br></br>
                <br></br>
                <div>
                    <Skeleton width="100%" height="10rem"></Skeleton>
                </div>
            </>
        );
    } else {
        bloqueAtributos = (
            <>
                <div className="flex justify-between flex-wrap">{bloqueCampos}</div>
            </>
        );
    }

    return (
        <Dialogo
            ventana={ventana}
            cabecera={header}
            modal={estadoDCF.flag.modal}
            posicionZ={ventana.posicionZ}
            pie={footer}
            estilo={{ width: "48rem", minHeight: "35vh", top: "15vh", margin: "0" }}
        >
            <div className="flex justify-between">
                <div>
                    <div className="flex">
                        <div className="w-40">Id. de Plan : </div>
                        <div>{estadoDCF.domain.screen.idPlan}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40"></div>
                        <div></div>
                    </div>
                </div>
                <div>
                    <div className="flex">
                        <div className="w-40 shrink-0">Fecha de Registro : </div>
                        <div>{estadoDCF.domain.screen.fechaReg}</div>
                    </div>
                    <div className="flex">
                        <div className="w-40">Estado : </div>
                        <div>{EstadosPlanLabel[estadoDCF.domain.screen.estado]}</div>
                    </div>
                </div>
            </div>

            <hr className="my-3"></hr>

            {bloqueAtributos}
        </Dialogo>
    );
};

export default DialogoPlanLayout;
